<template>
  <div class="w-80">
    <h3 class="mb-6 font-montserrat">{{ title }}</h3>

    <FormulateForm v-model="form" @submit="onSubmit">
      <div class="flex flex-col gap-4">
        <FormulateInput label="Full name" name="name" validation="required" />

        <FormulateInput
          name="email"
          label="Email"
          validation="required|email"
          :disabled="isUpserting"
        />

        <div class="flex flex-col gap-4 mt-3">
          <FormulateInput
            name="connectionsOnly"
            type="checkbox"
            label="This account is a self-managed connection"
            help="Checking this will restrict this account to only managing their individual Connection data. No other areas in your organisation's dashboard will be visible."
            :help-class="['mt-2']"
          />
        </div>

        <FormulateInput
          type="submit"
          :wrapper-class="['mt-4']"
          :input-class="['mb-0 group']"
          :element-class="['w-max mx-auto']"
          :disabled="isLoading"
        >
          <span :class="['font-nunito', { hidden: isLoading }]">{{
            submitText
          }}</span>
          <lottie
            :options="LOADING_ANIMATION_OPTIONS"
            :style="{ width: '1.5rem' }"
            :class="{ 'hidden': !isLoading, 'group-hover:hidden': isLoading }"
          />
          <lottie
            :options="LOADING_ANIMATION_OPTIONS_DARK"
            :style="{ width: '1.5rem' }"
            :class="{
              'hidden': !isLoading,
              'hidden group-hover:block': isLoading,
            }"
          />
        </FormulateInput>
      </div>
    </FormulateForm>
  </div>
</template>

<script>
import { defineComponent, ref, computed, onMounted } from 'vue'
import { useStore } from '../../../../js/store/index.js'
import { EventBus } from '../../../../js/plugins/event-bus'
import {
  LOADING_ANIMATION_OPTIONS,
  LOADING_ANIMATION_OPTIONS_DARK,
} from '../../../../js/util/constants.js'

export default defineComponent({
  name: 'ModalUpsertAccount',

  props: {
    config: { default: null },
  },

  setup(props) {
    const store = useStore()

    const isLoading = ref(false)
    const title = computed(() => {
      return isUpserting.value ? 'Edit Account' : 'Add Account'
    })
    const isUpserting = computed(() => !!accountId.value)
    const accountId = computed(() => props.config?.id || null)
    const account = computed(() => {
      if (accountId.value) {
        return store.getters['contributors/getAccount'](accountId.value)
      }

      return null
    })

    const form = ref({
      name: null,
      email: null,
      connectionsOnly: false,
    })

    const payload = computed(() => {
      if (isUpserting.value) {
        return {
          id: accountId.value,
          name: form.value.name,
          connections_only: form.value.connectionsOnly,
        }
      }

      return {
        name: form.value.name,
        email: form.value.email,
        connections_only: form.value.connectionsOnly,
      }
    })

    const submitText = computed(() => {
      return isUpserting.value ? 'Save' : 'Add'
    })

    const onSubmit = async () => {
      isLoading.value = true
      const success = await store.dispatch(
        'contributors/dispatchUpsertAccount',
        payload.value,
      )
      isLoading.value = false

      if (success) {
        EventBus.$emit('showModal', false)
        EventBus.$emit('triggerAlertResponse', {
          status: 'success',
          message: isUpserting.value ? 'Account udpated' : 'Account added',
        })
        EventBus.$emit('dispatchUpdateAccounts')
      }
    }

    const init = () => {
      if (isUpserting.value) {
        form.value.name = account.value.name
        form.value.email = account.value.email
        form.value.connectionsOnly = account.value.connections_only
      }
    }

    onMounted(() => init())

    return {
      title,
      LOADING_ANIMATION_OPTIONS,
      LOADING_ANIMATION_OPTIONS_DARK,
      isLoading,
      isUpserting,
      form,
      submitText,
      onSubmit,
    }
  },
})
</script>
